'use strict';
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'string') return argument;
  throw new $TypeError('Argument is not a string');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-string.js
// module id = 284
// module chunks = 0